<template>
  <b-row>
    <b-col cols="12">
      <form-user />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormUser from './FormUser.vue'

export default {
  components: {
    BRow,
    BCol,
    FormUser,
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
